import React, { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import { EventForm } from './EventForm';
import { Item } from '../../models';
import clientUtils from '../../utils/clientUtils';
import PanoramaOutlinedIcon from '@mui/icons-material/PanoramaOutlined';
import FuelCalendarHelper from './FuelCalendarHelper';
import { ChannelType } from '../../enums';
import { dateUtils } from '../../utils/dateUtils';
import EventIcon from '@mui/icons-material/Event';

interface IProps {
  eventInfo: any;
  activeView: string;
  calendarRef: any;
  events: EventForm[];
  clips: Item[];
  slotTime: string;
  viewAdBreaks: boolean;
  timezone: string;
  channelFormValues?: any;
}

const CALENDAR_TD_HEIGHT = 32;
const EventContentRender = ({
  eventInfo,
  activeView,
  calendarRef,
  events,
  clips,
  slotTime,
  timezone,
  viewAdBreaks,
  channelFormValues = null,
}: IProps) => {
  // console.log('eventInfo',eventInfo)
  const { current: calendarDom } = calendarRef;
  const eventsData = calendarDom.calendar.getEvents();
  const [channelType, setChannelType] = useState(channelFormValues ? channelFormValues.getValues('type') : 'None');
  const [adBreakType, setAdBreakType] = useState(
    channelFormValues ? channelFormValues.getValues('adsSponsorsForm.adBreakType') : 'None'
  );

  const isSeries = events.find((e) => e.id === eventInfo.event.id && e.rrule);
  const dif = dateUtils.getDifferenceFromDates(eventInfo.event.endStr, eventInfo.event.startStr);
  let showMultiLineContent = dif.hours > 0 ? true : false;
  const main = document.getElementById(eventInfo.event.id) as HTMLElement;
  const [assets, setAssets] = useState(clips);
  const [timeStamps, setTimeStamps] = useState([]);
  const [currentClip, setCurrentClip] = useState();
  const [thumbnailSrc, setThumbnailSrc] = useState<string | null>(null);
  let lastMarginTop = 0;
  // console.log('main', main);

  const init = async () => {
    if (eventInfo.event && eventInfo.event.id) {
      const event = events.find((e) => e.id === eventInfo.event.id);
      if (event && event.attachedFuelEntityId && event.attachedFuelEntityType) {
        const clipId = clientUtils.parseFuelEntityId(event.attachedFuelEntityId);
        let clip = assets.find((c) => c.id === clipId);
        if (clip) {
          if (clip.data && clip.data.timeStampMarkers) {
            // timeStampsArray = clip.data.timeStampMarkers[0].timeStamps;
            setTimeStamps(clip.data.timeStampMarkers[0].timeStamps);
          }
          const channelType = channelFormValues.getValues('type');
          if (
            clip &&
            clip.data &&
            clip.data.thumbnail &&
            clip.data.thumbnail.previewUri &&
            channelType.id !== ChannelType.Scheduled &&
            clip.schemaType === 'Image'
          ) {
            setThumbnailSrc(clip.data.thumbnail.previewUri);
          }
        }
      }
    }
  };

  const getPixel = () => {
    let pixel = 0;
    if (slotTime === '00:05:00') {
      pixel = CALENDAR_TD_HEIGHT / 5;
    } else if (slotTime === '00:06:00') {
      pixel = CALENDAR_TD_HEIGHT / 6;
    } else if (slotTime === '00:10:00') {
      pixel = CALENDAR_TD_HEIGHT / 10;
    } else if (slotTime === '00:15:00') {
      pixel = CALENDAR_TD_HEIGHT / 15;
    } else if (slotTime === '00:30:00') {
      pixel = CALENDAR_TD_HEIGHT / 30;
    } else if (slotTime === '00:60:00') {
      pixel = CALENDAR_TD_HEIGHT / 60;
    }
    return pixel;
  };
  const calculateMarginTop = (time, index) => {
    const seconds = time / 60 - 1;
    let pixel = getPixel();
    if (index === 0) {
      lastMarginTop = pixel * seconds;
      return `${pixel * seconds}px`;
    }
    let top = pixel * seconds - lastMarginTop;
    lastMarginTop = pixel * seconds;
    return `${top}px`;
  };
  useEffect(() => {
    init();
  }, []);

  const getClassNames = () => {
    const classNames = ['container'];
    const eventsData = calendarDom.calendar.getEvents();
    // console.log('eventsData', eventsData)
    const classNames2 = FuelCalendarHelper.getEventClassNames(eventInfo, eventsData, viewAdBreaks, channelType, adBreakType);
    classNames.push(...classNames2);
    return classNames.join(' ');
  };

  const parentEntityName = eventInfo.event._def?.extendedProps?.parentEntityName;
  const tooltipContent = (
    <>
      <div>{eventInfo.event.title}</div>
      <div>
        {dateUtils.format(eventInfo.event.startStr, timezone, 'hh:mm a')}-
        {dateUtils.format(eventInfo.event.endStr, timezone, 'hh:mm a')}
      </div>
      {parentEntityName && <div>{parentEntityName}</div>}
    </>
  );

  return (
    <Tooltip title={tooltipContent} arrow placement="top" enterDelay={500}>
      <div className={getClassNames()} id={eventInfo.event.id}>
        <div className="content-section ">
        {activeView !== 'dayGridMonth' && showMultiLineContent && (
          <>
            <div className="content">
              <p className="title">{eventInfo.event.title}</p>
             
              <b>
                {' '}
                {dateUtils.format(eventInfo.event.startStr, timezone, 'hh:mm a')}-
                {dateUtils.format(eventInfo.event.endStr, timezone, 'hh:mm a')}
              </b>
              {eventInfo.event._def &&
                eventInfo.event._def.extendedProps &&
                eventInfo.event._def.extendedProps.parentEntityName && (
                  <p className="sub-content">{eventInfo.event._def.extendedProps.parentEntityName}</p>
                )}
            </div>
            <div className="icons">
              {thumbnailSrc && <PanoramaOutlinedIcon className="recurrence-icon" />}
              {isSeries && !FuelCalendarHelper.hasOverlap(eventsData, eventInfo.event) && <SyncIcon className="recurrence-icon" />}
            </div>
          </>
        )}
        {activeView !== 'dayGridMonth' && !showMultiLineContent && (
          <>
            <div className="content">
              <div className="title-container ">
                <div className="title">{eventInfo.event.title}</div>
                {thumbnailSrc && dif.minutes < 30 && <PanoramaOutlinedIcon sx={{ fontSize: '12px' }} />}
              </div>
              {eventInfo.event._def &&
                eventInfo.event._def.extendedProps &&
                eventInfo.event._def.extendedProps.parentEntityName && (
                  <p className="sub-content">{dif.minutes > 25 && eventInfo.event._def.extendedProps.parentEntityName}</p>
                )}
              {dif.minutes > 25 && <>
                {' '}
                {dateUtils.format(eventInfo.event.startStr, timezone, 'hh:mm a')}-
                {dateUtils.format(eventInfo.event.endStr, timezone, 'hh:mm a')}
              </>}
              {dif.minutes > 25 && (
                <div className="icons">
                  {thumbnailSrc && <PanoramaOutlinedIcon className="recurrence-icon" />}
                  {isSeries && !FuelCalendarHelper.hasOverlap(eventsData, eventInfo.event) && <SyncIcon className="recurrence-icon" />}
                </div>
              )}
            </div>
          </>
        )}
        {activeView === 'dayGridMonth' && (
          <>
            <div className="fc-daygrid-event-dot"></div>
            <div className="fc-event-time"></div>
            <div className="fc-event-title">{eventInfo.event.title}</div>
            <div className="icons">
              {thumbnailSrc && <PanoramaOutlinedIcon className="recurrence-icon" />}
              {isSeries && <SyncIcon className="recurrence-icon" />}
            </div>
          </>
        )}
      </div>

      {channelType && channelType.id === ChannelType.Scheduled && viewAdBreaks && (
        <div className="ad-break-section">
          {timeStamps.map((t, i) => {
            return <div key={t} style={{ borderTop: '2px solid yellow', marginTop: calculateMarginTop(t, i) }}></div>;
          })}
        </div>
      )}
      </div>
    </Tooltip>
  );
};

export default EventContentRender;
